const DebugProvider = () => {
    /* eslint-disable */
    console.info('Tracking: debug provider loaded');

    return {
        track: console.info,
    };
    /* eslint-enable */
};

const getProviders = (config) => {
    let p = [];
    if (config.debug) p.push(DebugProvider());
    return p;
};

export {
    getProviders,
    DebugProvider,
};
